import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BaseValidationService } from '../services/base-validation.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { TransactionsService } from '../../../../services/ServiceEntity/transactions.service';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../shared/services/form.service';
import { TCModalService } from '../../../../ui/services/modal/modal.service';
import { CONTENT_BTN_CLASS, POPUP_CONTAINER_CLASS } from '../../../../shared/constant/css-style/css-class.constant';
import { TransactionInfosRetrait } from '../../../../model/transaction/transaction-infos-retrait.model';
import {
  SERVICE_ITEM_ID_INFOS_TRANSACTION_RETRAIT_CODE,
  SERVICE_ITEM_ID_RETRAIT_CODE_CASH
} from '../../../../shared/constant/service-item.constant';
import { ICashModel } from '../cash-data-model';

/**
 * Permet d'afficher les informations de la transaction
 * avant d'effectuer un retrait code complet.
 */
@Component({
  selector: 'app-retrait-code-complet-infos',
  templateUrl: './retrait-code-complet-infos.component.html',
  animations: [fadeIn]
})
export class RetraitCodeCompletInfosComponent extends BaseValidationService
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;

  loadingMessagesForm = false;
  theDialogRef: MatDialogRef<RetraitCodeCompletInfosComponent>;
  private subs$ = new Subject<void>();

  transactionInfos: TransactionInfosRetrait;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ICashModel,
    private transactionsService: TransactionsService,
    private accountService: AccountService,
    private formService: FormService,
    private dialogRef: MatDialogRef<RetraitCodeCompletInfosComponent>,
    protected modal: TCModalService) {
    super(modal);
    console.log('## construct retrait code complet infos');
    this.theDialogRef = this.dialogRef;
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    let p = new FormData();
    p.set('serviceItemId', this.tostring(SERVICE_ITEM_ID_INFOS_TRANSACTION_RETRAIT_CODE));
    p.set('valueCode', this.tostring(this.data.cashDataModel.dataForm.data.get('valueCode')));
    p.set('sentAmount', this.tostring(this.data.cashDataModel.dataForm.data.get('sentAmount')));
    p.set('serviceId', this.tostring(SERVICE_ITEM_ID_RETRAIT_CODE_CASH));
    // on ferme après avoir ouvert le popup du résultat de la transaction.
    this.dialogRef.afterClosed().subscribe(res => {
      console.log('## popup closed');
      this.data.cashDataModel.dialogRef.close();
    });
    this.transactionsService.execute(p).subscribe(res => {
      let data = res.body;
      console.log('## success récupération infos transaction: ', data);
      this.transactionInfos = data;
      this.data.cashDataModel.transactionInfosRetrait = data;
    }, err => {
      console.log('## Erreur récupération infos transaction: ', err);
    })
  }

  tostring(s: any) {
    return s + '';
  }

  format(n: any) {
    console.log('## type amount: ', typeof (+n));
    return this.formService.format(+n);
  }

  getInit() {
    if(!this.transactionInfos) {
      return false;
    }
    return true;
  }

  getAmountReceive() {
    const amount: number = +this.data.cashDataModel.dataForm.data.get('sentAmount');
    return this.format((amount - this.transactionInfos?.fees));
  }

  confirm() {
    console.log('## confirm retrait code complet');
    this.data.cashDataModel.dataForm.loadingMessagesForm = true;
    this.loadingMessagesForm = true;
    const d = this.data.cashDataModel.dataForm;
    this.transactionsService.withdrawalv2(d.data).subscribe((rep) => {
      console.log('### SUCCESS Retrait ALL CASH OUT', rep);
      this.loadingMessagesForm = false;
      this.manageMessageWhenSucceed(rep, d);
      d.reponseTransfert = rep.body;
      this.openModal(d.forModal, 'Resultats du retrait CODE COMPLET',
        null, { closeButton: true, overlayClose: false }, POPUP_CONTAINER_CLASS);
      this.dialogRef.close();
      d.nextFormData.formulaire.reset();
    }, err => {
      console.log('### ERROR Retrait ALL CASH OUT', err);
      this.loadingMessagesForm = false;
      this.manageMessageWhenError(d);
    });
  }

  getContentClass() {
    return CONTENT_BTN_CLASS;
  }

}